var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 289,
    viewBox: "0 0 343 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 62H298ZM6 73.2H298ZM50.9231 151.6H140.769ZM50.9231 185.2H95.8462ZM39.6923 230H264.308C273.243 230 281.813 226.46 288.132 220.159C294.45 213.858 298 205.311 298 196.4V39.6C298 30.6887 294.45 22.1424 288.132 15.8412C281.813 9.53999 273.243 6 264.308 6H39.6923C30.7566 6 22.1868 9.53999 15.8682 15.8412C9.54971 22.1424 6 30.6887 6 39.6V196.4C6 205.311 9.54971 213.858 15.8682 220.159C22.1868 226.46 30.7566 230 39.6923 230Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 62H298M6 73.2H298M50.9231 151.6H140.769M50.9231 185.2H95.8462M39.6923 230H264.308C273.243 230 281.813 226.46 288.132 220.159C294.45 213.858 298 205.311 298 196.4V39.6C298 30.6887 294.45 22.1424 288.132 15.8412C281.813 9.53999 273.243 6 264.308 6H39.6923C30.7566 6 22.1868 9.53999 15.8682 15.8412C9.54971 22.1424 6 30.6887 6 39.6V196.4C6 205.311 9.54971 213.858 15.8682 220.159C22.1868 226.46 30.7566 230 39.6923 230Z",
    stroke: "#333333",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 214,
    r: 70,
    fill: "white",
    stroke: "#871212",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241 240.5L294.5 187M241 187L294.5 240.5",
    stroke: "#871212",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutCancelled);
export default __webpack_public_path__ + "static/media/checkout-cancelled.d9bdc61b6c786b452f6b138e56054e40.svg";
export { ForwardRef as ReactComponent };